module.exports = __webpack_public_path__ + "advancedSlide.jpg?76ff35f64ccd7ad35a5b3323676996fc";